import React, { useState } from 'react';
import './FAQPage.css';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is CBC Center really free?",
      answer: "Yes! All resources on CBC Center are completely free for students, teachers, and parents. We believe in providing equal access to quality educational materials without any cost barriers."
    },
    {
      question: "How often are the resources updated?",
      answer: "We update our resources regularly to align with the latest CBC curriculum changes. Our team monitors official curriculum updates and revises materials accordingly, typically within 2-4 weeks of any announced changes."
    },
    {
      question: "Can I download materials for offline use?",
      answer: "Yes, you can download most of our resources. Simply click the download button on any document card. Some resources like past papers and worksheets are available as PDF downloads for offline access."
    },
    {
      question: "Are the materials suitable for homeschooling?",
      answer: "Absolutely! Our resources are designed to support various learning environments including homeschooling, traditional classrooms, and tutoring. Parents can use our materials to supplement their children's learning at home."
    },
    {
      question: "How can teachers use CBC Center?",
      answer: "Teachers can use our platform for lesson planning, accessing teaching guides, downloading worksheets, and finding assessment materials. All resources are organized by grade and subject for easy navigation."
    },
    {
      question: "What grades are covered?",
      answer: "We currently cover all primary school grades (Grade 1 to Grade 8) under the CBC system. We're continuously expanding to include more grade levels and subjects."
    },
    {
      question: "How do I report an error in content?",
      answer: "If you find any errors or issues with our content, please contact us at support@cbccenter.co.ke with details about the specific resource and the error you found. We appreciate your help in maintaining quality standards."
    },
    {
      question: "Can I contribute resources to CBC Center?",
      answer: "We welcome contributions from qualified educators! If you have quality CBC resources you'd like to share, please contact us at contributions@cbccenter.co.ke. All submissions go through our review process before publication."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">
            Find answers to common questions about CBC Center and our resources
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="question-text">{faq.question}</span>
                <span className="toggle-icon">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQPage;